// src/hooks/useAdmins.ts
import { useQuery } from "@tanstack/react-query";
import { getAllAdmins } from "../services/adminServices";
import { getMaintainerAll } from "../services/maintainerServices";

export const useAdmins = ({ limit, lastId } = {}) => {
  return useQuery({
    queryKey: ["admins", limit, lastId],
    queryFn: () => getAllAdmins({ limit, lastId }),
    keepPreviousData: true,
  });
};

export const useMaintainer = () => {
  return useQuery({
    queryKey: ["maintainter"],
    queryFn: () => getMaintainerAll(),
    keepPreviousData: true,
  });
};
